import { jsx as _jsx } from "react/jsx-runtime";
import IconContainer from '../IconContainer/IconContainer';
import classNames from 'classnames';
const TooltipArrow = ({ containerClasses, iconClasses = 'black-primary' }) => {
    return (_jsx(IconContainer, { width: 36, height: 8, className: containerClasses, children: _jsx("path", { className: classNames('svg-icon-fill no-transition', iconClasses), fillRule: "evenodd", clipRule: "evenodd", d: "M18.5 8C21.5 8 24.4999 0 28.5 0H8.5C12.4749 0 15.5 8 18.5 8Z" }) }));
};
export default TooltipArrow;
